var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenancy-tenant-view-info-wrapper" }, [
    _c("div", { staticClass: "main-content" }, [
      _c(
        "div",
        { staticClass: "basic-info-column" },
        [
          _c("div", { staticClass: "column-header" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("tenancy.basicInfo")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contents" }, [
            _c(
              "div",
              { staticClass: "column-content" },
              [
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.companyId"),
                    value: _vm.deep(_vm.currentTenancy, "company.id"),
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.companyName"),
                    value: _vm.deep(_vm.currentTenancy, "company.name"),
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.tradeName"),
                    value: _vm.currentTenancy.tradeName || "--",
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.phoneNumber"),
                    value:
                      _vm.deep(_vm.currentTenancy, "company.phone") || "--",
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.alternativePhoneNumber"),
                    value:
                      _vm.deep(_vm.currentTenancy, "company.altPhone") || "--",
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.faxNumber"),
                    value: _vm.deep(_vm.currentTenancy, "company.fax") || "--",
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.email"),
                    value:
                      _vm.deep(_vm.currentTenancy, "company.email") || "--",
                    showColon: false,
                    readonly: true,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column-content column-content-right" },
              [
                _c("TextField", {
                  staticClass: "building",
                  attrs: {
                    label: _vm.$t("tenancy.building"),
                    value:
                      _vm.deep(_vm.currentTenancy, "building.fullName") || "--",
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.floor"),
                    value: _vm.effectiveFloors,
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.type"),
                    value: _vm.tenancyTypeValue,
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                !_vm.showHolidayHour
                  ? _c("div", { staticClass: "tenancy-working-hours" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("tenancy.openingHours"))),
                      ]),
                      _vm._v(" "),
                      _vm.regularOpeningHours.length
                        ? _c(
                            "ul",
                            { staticClass: "tenancy-working-hours-list" },
                            _vm._l(
                              _vm.regularOpeningHours,
                              function (item, index) {
                                return _c("li", { key: index }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("customWorkingDayLabel")(
                                          item.workingDayFrom
                                        )
                                      )
                                    ),
                                  ]),
                                  item.workingDayTo
                                    ? _c("span", [_vm._v(" - ")])
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    { staticClass: "u-margin-right-small" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("customWorkingDayLabel")(
                                            item.workingDayTo
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("customWorkingHourLabel")(
                                          item.workingHourFrom
                                        )
                                      )
                                    ),
                                  ]),
                                  item.workingHourTo
                                    ? _c("span", [_vm._v(" - ")])
                                    : _vm._e(),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("customWorkingHourLabel")(
                                          item.workingHourTo
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              }
                            ),
                            0
                          )
                        : _c("div", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("emptyValue")) +
                                "\n            "
                            ),
                          ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isOffice && _vm.enableDirectoryFeature
                  ? _c("div", { staticClass: "directory-link" }, [
                      _c("a", { on: { click: _vm.navToDirectory } }, [
                        _vm._v(_vm._s(_vm.$t("directory.requisition"))),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.showHolidayHour ? _c("TenancyOpeningHour") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "alarm-section" }, [
            _c("div", { staticClass: "alarm-section__label-btn" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("tenancy.tenantAlarmSysHint"))),
              ]),
              _vm._v(" "),
              _vm.canUpdateAlarm && _vm.isMaster
                ? _c("div", { staticClass: "alarm-section__btn-group" }, [
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isEditAlarm,
                          expression: "!isEditAlarm",
                        },
                      ],
                      staticClass: "fa fa-pencil",
                      on: {
                        click: function ($event) {
                          _vm.isEditAlarm = true
                        },
                      },
                    }),
                    _vm._v(" "),
                    !_vm.isEditAlarm
                      ? _c(
                          "button",
                          {
                            staticClass: "alarm-section__btn btn--withoutcolor",
                            attrs: { role: "edit-button" },
                            on: {
                              click: function ($event) {
                                _vm.isEditAlarm = true
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("action.edit")) +
                                "\n            "
                            ),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "alarm-section__btn btn--withoutcolor",
                            attrs: { role: "save-button" },
                            on: {
                              click: function ($event) {
                                return _vm.saveAlarm()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("action.save")) +
                                "\n            "
                            ),
                          ]
                        ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fire-alarm-section" }, [
              _c("label", { staticClass: "emphasis alarm-label" }, [
                _vm._v(_vm._s(_vm.$t("tenancy.fireAlarmSystem")) + ":"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                staticClass: "alarm-checkbox",
                attrs: {
                  type: "radio",
                  name: "fireAlarm",
                  disabled: !_vm.isEditAlarm,
                },
                domProps: { checked: _vm.currentTenancy.isFireAlarm },
                on: {
                  change: function ($event) {
                    return _vm.updateTenancyByPath("isFireAlarm", true)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "alarm-checkbox-label" }, [
                _vm._v(_vm._s(_vm.$t("action.yes"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                staticClass: "alarm-checkbox",
                attrs: {
                  type: "radio",
                  name: "fireAlarm",
                  disabled: !_vm.isEditAlarm,
                },
                domProps: {
                  checked:
                    _vm.currentTenancy.isFireAlarm !== null &&
                    !_vm.currentTenancy.isFireAlarm,
                },
                on: {
                  change: function ($event) {
                    return _vm.updateTenancyByPath("isFireAlarm", false)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "alarm-checkbox-label" }, [
                _vm._v(_vm._s(_vm.$t("action.no"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("label", { staticClass: "emphasis alarm-label" }, [
                _vm._v(_vm._s(_vm.$t("tenancy.burglarAlarmSystem")) + ":"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                attrs: {
                  type: "radio",
                  name: "burglarAlarm",
                  disabled: !_vm.isEditAlarm,
                },
                domProps: { checked: _vm.currentTenancy.isBurglarAlarm },
                on: {
                  change: function ($event) {
                    return _vm.updateTenancyByPath("isBurglarAlarm", true)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "alarm-checkbox-label" }, [
                _vm._v(_vm._s(_vm.$t("action.yes"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                attrs: {
                  type: "radio",
                  name: "burglarAlarm",
                  disabled: !_vm.isEditAlarm,
                },
                domProps: {
                  checked:
                    _vm.currentTenancy.isBurglarAlarm !== null &&
                    !_vm.currentTenancy.isBurglarAlarm,
                },
                on: {
                  change: function ($event) {
                    return _vm.updateTenancyByPath("isBurglarAlarm", false)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "alarm-checkbox-label" }, [
                _vm._v(_vm._s(_vm.$t("action.no"))),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "building-management-column" }, [
        _c("div", { staticClass: "column-header" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("tenancy.hkldInformation")) +
              "\n        "
          ),
          _c(
            "div",
            { staticClass: "sow-hint" },
            [
              _c("Popover", {
                attrs: {
                  text: _vm.$t("tenancy.hkldInfoTip"),
                  position: "bottom-right",
                  width: 300,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column-content" },
          [
            _c("TextField", {
              attrs: {
                label: _vm.$t("tenancy.customerServiceHotline"),
                value:
                  _vm.deep(
                    _vm.currentTenancy,
                    "physicalSite.officeTelephone"
                  ) || "--",
                showColon: false,
                readonly: true,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "location-contacts" },
              [
                _c("TenancyLocationContacts", {
                  attrs: {
                    title: _vm.$t("tenancy.propertyManagement"),
                    contacts: _vm.propertyManagementContacts,
                  },
                }),
                _vm._v(" "),
                _c("TenancyLocationContacts", {
                  attrs: {
                    title: _vm.$t("tenancy.technicalServices"),
                    contacts: _vm.technicalServicesContacts,
                  },
                }),
                _vm._v(" "),
                _c("TenancyLocationContacts", {
                  attrs: {
                    title: _vm.$t("tenancy.assetManagement"),
                    contacts: _vm.assetManagementContacts,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                label: _vm.$t("tenancy.manageOfficeAddr"),
                value:
                  _vm.deep(_vm.currentTenancy, "physicalSite.officeLocation") ||
                  "--",
                showColon: false,
                readonly: true,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "regulations-links" },
              _vm._l(_vm.redirectLinksList, function (link) {
                return _c(
                  "a",
                  {
                    key: link.key,
                    staticClass: "name-hyper-link",
                    attrs: { href: link.value, target: "_blank" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tenancy." + link.key)) +
                        "\n          "
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.showHotbList
      ? _c(
          "div",
          { staticClass: "hotb-section" },
          [_c("HotbList", { attrs: { tenancyId: _vm.tenancyId } })],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }